import React, { useState } from 'react';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';
import buyerService from './buyer.service';
import { Value } from 'sass';

const BuyerAdd = (props) => {
 
   let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key],
          };
        }
      });
      return updatedValues;
    });
  };

  const [inputProps, setInputProps] = useState({
    buyerNTNCNIC: {
      name: 'buyerNTNCNIC',
      caption: 'Buyer NTN/CNIC',
      value: props.buyerNTNCNIC || ''
    },
    buyerBusinessName: {
      name: 'buyerBusinessName',
      caption: 'Buyer Business Name',
      value: props.buyerBusinessName || ''
    },
    stateProvinceName: {
      name: { id: 'stateProvinceCode', value: 'stateProvinceName' },
      caption: 'Select Province',
      value: {
        id: props.buyerProvinceCode || '',
        value: props.buyerProvinceName || ''
      },
      dataSource: { type: 'Data', data: [] }
    },
    buyerAddress: {
      name: 'buyerAddress',
      caption: 'Buyer Address',
      value: props.buyerAddress || ''
    },
    buyerRegistrationType: {
      name: 'buyerRegistrationType',
      caption: 'Buyer Registration Type',
      value: props.buyerRegistrationType || null
    },
    sellerNTNCNIC: {
      name: 'sellerNTNCNIC',
      caption: 'Seller NTN/CNIC',
      value: props.sellerNTNCNIC || null
    }
  });

  const getProvincesSource = async () => {
    const response = await buyerService.getCompanyView();
    const { data } = await buyerService.getProvincesDD(response.data.recordset[0].CompanyID);
    console.log(data)
    const recordsMapping = (data || []).map((row) => ({
      id: row.stateProvinceCode,
      value: row.stateProvinceDesc
    }));

    updateMainSecionsValue({
      stateProvinceName: {
        dataSource: { type: 'Data', data: recordsMapping }
      }
    });
    setTimeout(() => {
      
      if(props.isAdd == false){
        updateMainSecionsValue({
          stateProvinceName: {
            value:{ value:{ id: props.buyerProvinceCode, value: props.buyerProvinceName }}
          }
        });
      }
    }, 500);
  };

  const handleInputCreated = async (e, name) => {
    if (name === 'stateProvinceName') {
      getProvincesSource();
    }
    console.log(`Input ${name} created`, e);
  };

  const inputsList = [
    { Input: TextComponent, Props: { ...inputProps.buyerNTNCNIC, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.buyerBusinessName, setInputProps }, ColumnSize: 6 },
    {
      Input: DropdownComponent,
      Props: { ...inputProps.stateProvinceName, setInputProps, onCreated: handleInputCreated },
      ColumnSize: 6
    },
    { Input: TextComponent, Props: { ...inputProps.buyerAddress, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.buyerRegistrationType, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.sellerNTNCNIC, setInputProps }, ColumnSize: 6 }
  ];

  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <StructuredGenerate
        mainProps={props}
        title={`Buyer - ${props.isAdd ? 'Add' : 'Edit'}`}
        Inputs={inputsList}
      />
    </div>
  );
};

export default BuyerAdd;